var _ellipse, _circle, _ellipse2, _path, _path2, _ellipse3, _ellipse4, _circle2, _ellipse5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyes5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 40,
    viewBox: "0 0 100 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.6928,
    cy: 22.4726,
    rx: 11.518,
    ry: 11.518,
    fill: "#201714"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.06388,
    cy: 18.7167,
    r: 3.38028,
    fill: "#F7F7F7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.8242,
    cy: 27.8557,
    rx: 1.87793,
    ry: 1.87793,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.8747 12.5196C91.4365 10.1659 94.2868 3.19249 94.7667 0C95.3301 9.70266 90.4684 13.5003 86.3786 15.4617L83.8747 12.5196Z",
    fill: "#201714"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5889 18.7973C89.3978 14.7525 96.4873 17.3002 99.181 19.0797C92.3472 12.1689 86.272 13.241 82.0779 14.9679L82.5889 18.7973Z",
    fill: "#201714"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.25822,
    cy: 5.25822,
    rx: 5.25822,
    ry: 5.25822,
    transform: "matrix(-1 0 0 1 83.5615 29.4834)",
    fill: "#E97A7A"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.518,
    cy: 11.518,
    rx: 11.518,
    ry: 11.518,
    transform: "matrix(-1 0 0 1 89.8213 10.9546)",
    fill: "#201714"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.38028,
    cy: 3.38028,
    r: 3.38028,
    transform: "matrix(-1 0 0 1 84.3125 15.3364)",
    fill: "#F7F7F7"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.87793,
    cy: 1.87793,
    rx: 1.87793,
    ry: 1.87793,
    transform: "matrix(-1 0 0 1 76.0498 25.9778)",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes5);
export default __webpack_public_path__ + "static/media/eyes-5.291d4d2f84a5f0958b68e6a2d6c0262d.svg";
export { ForwardRef as ReactComponent };